/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Freename1Inputs */

const zh_pricing_freename1 = /** @type {(inputs: Pricing_Freename1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费版`)
};

const en_pricing_freename1 = /** @type {(inputs: Pricing_Freename1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free`)
};

const es_pricing_freename1 = /** @type {(inputs: Pricing_Freename1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis`)
};

/**
* | output |
* | --- |
* | "Free" |
*
* @param {Pricing_Freename1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const pricing_freename1 = /** @type {((inputs?: Pricing_Freename1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Freename1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_pricing_freename1(inputs)
	if (locale === "en") return en_pricing_freename1(inputs)
	return es_pricing_freename1(inputs)
});
export { pricing_freename1 as "pricing_freeName" }